import { render, staticRenderFns } from "./LensAvatar.vue?vue&type=template&id=74a95b22"
import script from "./LensAvatar.vue?vue&type=script&lang=js"
export * from "./LensAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports